<template>
  <div class="bg">
    <div class="sharetip" v-if="share" @click="share = false">
      <div class="s"></div>
    </div>
    <div class="title"></div>
    <div class="text">
      <div class="yb-result-txt-inner" v-html="data.ybResultHTML"></div>

      <div class="side-man">
        <div class="inner-abs-box">
          <img
            class="img"
            :src="
              '//cdn.original-fun.com/gugong/' + data.ybResultImg + '.png'
            "
            :style="data.sideCfg"
          />
        </div>
      </div>
    </div>

    <div class="btn b1" @click="goGuide"></div>
    <div class="btn b2" @click="share = true"></div>
    <div class="btn b3" @click="go('http://act.uu.cc/bd/new.php?id=2339')"></div>
    <div class="logo"></div>
  </div>
</template>

<script>
//script
import Tools from "../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../scripts/Global";

export default {
  data() {
    return {
      share: false,
      data: {
        ...Global.curr
      }
    };
  },
  components: {},
  created() {
    Global.pauseAll();
  },
  computed: {},
  methods: {
    go(p) {
      window.location.href = p;
    },
    goGuide() {
      window.Global.pauseAll();
      this.$router.replace({ name: "Home", query: { gameType: "guide" } });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.yb-result-txt-inner {
  p {
    margin: 0.5rem 0 0 0;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.bg {
  background-image: url(//cdn.original-fun.com/gugong/BG.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}

.title {
  background-image: url(//cdn.original-fun.com/gugong/未集齐文案.png);
  background-position: center;
  width: 6rem;
  height: 2rem;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 1rem auto 0rem auto;
  position: relative;
}

.text {
  width: 3.1rem;
  font-size: 12px;
  margin: 0rem 0 0.5rem 0.8rem;
  padding: 0.1rem 0.2rem 0.1rem 0rem;
  text-align: left;
  line-height: 0.4rem;
}

.btn {
  background-image: url(//cdn.original-fun.com/gugong/button分享给朋友.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 3.5rem;
  height: 1rem;
  margin: 0 0 0 0.8rem;

  &.b1 {
    background-image: url(//cdn.original-fun.com/gugong/button游览其他线路.png);
  }
  &.b2 {
    background-image: url(//cdn.original-fun.com/gugong/button分享给朋友.png);
  }
  &.b3 {
    background-image: url(//cdn.original-fun.com/gugong/button更多活动.png);
  }
}

.logo {
  background-image: url(//cdn.original-fun.com/gugong/品牌logo-白.png);
  background-position: center;
  width: 3rem;
  height: 1rem;
  background-repeat: no-repeat;
  background-size: contain;

  position: absolute;
  bottom: 0.5rem;
  left: 50%;
  margin-left: -1.5rem;
}

.side-man {
  pointer-events: none;
  position: absolute;
  width: 4rem;
  top: 3rem;
  right: 0rem;
  height: 9rem;
  .inner-abs-box {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .img {
    height: 100%;
  }
}
</style>
